<template>
	<v-container>
		<Snackbar v-if="errored" msg="Error from Server" />
		<Snackbar v-if="deleted" msg="Operation Successfull" />
		<v-dialog v-model="create" width="75%">
			<v-card>
				<NewActivity ref="createDialog"/>
			</v-card>
		</v-dialog>
		<v-dialog v-model="edit" width="75%">
			<v-card>
				<EditActivity :editId="editId" ref="editDialog"/>
			</v-card>
		</v-dialog>	
		<v-card-title>
			Activities
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
			<v-btn
				color="success"
				class="ml-8"
				@click="create = !create"
			>
				New
				<v-icon class="ms-2">
					mdi-plus
				</v-icon>
			</v-btn>			
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="activities"
			:search="search"
			class="elevation-1"
		>
			<template v-slot:[`item.date`]="{ item }">
				<span>{{ formateDate(item.date) }}</span>
			</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="primary"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="(editId = item._id) && (edit = !edit)"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span> Edit </span>
				</v-tooltip>                
				<v-tooltip right>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="error"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="confirmDelete() && deleteActivity(item)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</template>
					<span> Delete </span>
				</v-tooltip>
			</template>			
		</v-data-table>
	</v-container>
</template>

<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
import NewActivity from '../Activities/New.vue'
import EditActivity from '../Activities/Edit.vue'

export default {
  name: 'Activities',
	components: {
		Snackbar,
		NewActivity,
		EditActivity
	},	
  data: () => ({
    loading: true,
    errored: false,
    deleted: false,
		create: false,
		edit: false,
		editId: null,		
    activities: [],
		search: '',
		headers: [
			{ text: 'Title', value: 'title', width: '50%', align: 'start' },
			{ text: 'Categories', value: 'category', width: '25%', align: 'start' },
			{ text: 'Date', value: 'date', align: 'center', width: '15%' },
			{ text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '10%' }
		]
  }),
	mounted() {
		this.getActivities();
	},
	methods: {
		formateCategories(category){
			let allCategories = '';
			for(var i=0; i<category.length; i++){
				allCategories += category[i].name;
				if(category[i+1]){
					allCategories += ", ";
				}
			}
			return allCategories;
		},

		formateDate(date){
			return new Date(date).toLocaleDateString('es', { year: "numeric", month: "2-digit", day: "2-digit" });
		},

		formateActivities(){
			this.activities.forEach(e => {
				e.category = this.formateCategories(e.category);
			});
			return;
		},

		getActivities(){
			axios
			.get(`/activity/dashboard/`)
			.then(res => {
				this.activities = res.data.data;
				this.formateActivities();
			})
			.catch(err => {
				console.error("axios err", err);
				this.errored = true;
			})
			.finally(() => this.loading = false);
		},

		confirmDelete(){
			return confirm("Are you sure you want to delete this activity?");
		},

		deleteActivity(activity){
			axios
			.delete(`/activity/`, {data: {_id: activity._id}})
			.then(() => {
        this.deleted = true
				this.getActivities();
			})
			.catch(err => {
				console.error("error", err);
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			});
		}
	},
	watch: {
		create: function(){
			if(!this.create){
				this.getActivities();
				this.$refs.createDialog.reset();
			}
		},

		edit: function(){
			if(!this.edit){
				this.getActivities();
				this.editId = null;
				this.$refs.editDialog.reset();
			}
		}		
	}
}
</script>

<style>

</style>